module.exports = __webpack_public_path__ + "img/qrcode_258.86d0d12f.jpg";